import SearchSubscriptions from "./search";
import ExportSubscriptions from "./export";
export const baseUrl = "/company/:company_id/subscription";
export default (axiosConfig, options) => ({
  export: ExportSubscriptions(axiosConfig, options),
  search: SearchSubscriptions(axiosConfig, options)
});